import * as Yup from 'yup';
import {
  lessThanXCharsNotEndBacklash,
  lessThanXCharsNotEndBacklashRequired,
  numberBetweenXAndY,
} from '../../../helpers/validationSchemaHelpers';

export const nameValidationSchema = lessThanXCharsNotEndBacklashRequired('name', 15);

export const staffRoleIdValidationSchema = Yup.object({
  staffRoleId: Yup.string().required('validation.fieldRequired'),
});

export const hourlyRateValidationSchema = numberBetweenXAndY('hourlyRate', 0, 999999.99);
export const passcodeValidationSchema = lessThanXCharsNotEndBacklash('password', 10);

export const mainLocationIdValidationSchema = Yup.object({
  mainLocationId: Yup.string().nullable(),
});

const validationSchema = Yup.object({
  showAtAllLocations: Yup.boolean(),
})
  .concat(nameValidationSchema)
  .concat(staffRoleIdValidationSchema)
  .concat(hourlyRateValidationSchema)
  .concat(passcodeValidationSchema)
  .concat(mainLocationIdValidationSchema);

export default validationSchema;
